export default __webpack_public_path__ + "static/media/play.cc5398a6.png";